module.exports = __webpack_public_path__ + "img/4ab904ad573bce71d045b42ace5feac7.png";